var giphy_viewer_default = {
  "giphyWrapper": "sVq9R",
  "giphy_player": "q2nf8",
  "playIcon": "a-XVa",
  "gifRatio": "-mjVW"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
